export const USER_ROLE = {
  student: "student",
  teacher:  "teacher",
  admin: "admin",
}

export const API_URL = process.env.REACT_APP_API_URL;
